import React, { createContext, useContext, useState, useEffect } from 'react';
import { Step } from 'react-joyride';

interface OnboardingContextType {
  isGuideActive: boolean;
  startGuide: () => void;
  stopGuide: () => void;
  stepIndex: number;
  setStepIndex: (index: number) => void;
  steps: Step[];
}

const initialSteps: Step[] = [
  {
    target: 'body',
    content: 'Bienvenue dans votre espace profil ! Je vais vous guider à travers les différentes fonctionnalités.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.profile-info-section',
    content: 'Dans cette section, vous pouvez remplir vos informations personnelles comme votre nom, titre, et description.',
    placement: 'bottom',
  },
  {
    target: '.social-links-tab',
    content: 'Cliquez sur cet onglet pour ajouter vos réseaux sociaux et faciliter les contacts.',
    placement: 'bottom',
  },
  {
    target: '.personnalisation-tab',
    content: 'Dans cet onglet, vous pourrez personnaliser votre profil avec un QR code unique et un fond d\'écran personnalisé.',
    placement: 'bottom',
    spotlightClicks: true
  },
  {
    target: '.partage-tab',
    content: 'Accédez à votre profil public et partagez-le avec vos contacts professionnels.',
    placement: 'bottom',
    spotlightClicks: true
  }
];

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export const OnboardingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isGuideActive, setIsGuideActive] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [steps] = useState<Step[]>(initialSteps);

  const startGuide = () => {
    console.log('Starting guide with', initialSteps.length, 'steps');
    setIsGuideActive(true);
    setStepIndex(0);
  };

  const stopGuide = () => {
    console.log('Stopping guide...');
    setIsGuideActive(false);
    setStepIndex(0);
    localStorage.setItem('hasSeenGuide', 'true');
  };

  useEffect(() => {
    // Vérifier si c'est la première visite
    const hasSeenGuide = localStorage.getItem('hasSeenGuide');
    if (!hasSeenGuide) {
      startGuide();
    }
  }, []);

  return (
    <OnboardingContext.Provider
      value={{
        isGuideActive,
        startGuide,
        stopGuide,
        stepIndex,
        setStepIndex,
        steps,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};
